import React, { useEffect, useRef, useCallback } from "react";
import "./chat.css";

const ChatMessages = ({ messages, userId }) => {
  const messagesEndRef = useRef(null);

  const scrollToBottom = useCallback(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (messagesEndRef.current) {
      const rect = messagesEndRef.current.getBoundingClientRect();
      if (rect.top >= 0) {
        scrollToBottom();
      }
    }
  }, [messages, scrollToBottom]);

  // DEBUG: Log userId and first message for debugging
  useEffect(() => {
    if (messages.length > 0) {
      console.log("🔍 DEBUG ChatMessages:");
      console.log("  userId (current user):", userId, typeof userId);
      console.log("  Sample message:", messages[0]);
      console.log("  Sample sender ID:", messages[0].sender_id || messages[0].senderId || messages[0].sender);
    }
  }, [messages, userId]);

  return (
    <div className="chat-messages">
      {messages.length === 0 ? (
        <div className="no-messages">
          No messages yet. Start a conversation!
        </div>
      ) : (
        messages.map((msg, i) => {
          // Robust check for sender ID across different field name variations
          const msgSenderId = msg.sender_id || msg.senderId || msg.sender;
          const isSentByMe = String(msgSenderId || '').trim() === String(userId || '').trim();

          const messageText = msg.message || msg.text || '';
          const timestamp = msg.created_at || msg.time;

          return (
            <div
              key={msg.id || msg.tempId || `temp-${i}`}
              className={`message-row ${isSentByMe ? 'sent' : 'received'}`}
            >
              <div className={`chat-bubble ${isSentByMe ? "sender" : "receiver"}`}>
                <div className="message-text">{messageText}</div>
                {timestamp && (
                  <div className="message-time">
                    {new Date(timestamp).toLocaleTimeString([], {
                      hour: '2-digit',
                      minute: '2-digit'
                    })}
                  </div>
                )}
              </div>
            </div>
          );
        })
      )}
      <div ref={messagesEndRef} />
    </div>
  );

};

export default ChatMessages;
